import { render, staticRenderFns } from "./ManagementInviteUserList.vue?vue&type=template&id=20b9ccca&scoped=true"
import script from "./ManagementInviteUserList.vue?vue&type=script&lang=js"
export * from "./ManagementInviteUserList.vue?vue&type=script&lang=js"
import style0 from "./ManagementInviteUserList.vue?vue&type=style&index=0&id=20b9ccca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9ccca",
  null
  
)

export default component.exports